import { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import { useMatch, useNavigate } from 'react-router-dom';
import { t } from '@/utils/i18n';
import { getActiveUserDraft } from '@/redux/userDrafts/getters/getActiveUserDraft';
import { LoadingOverlay } from '@/components/common/LoadingOverlay';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalTypes,
} from '@/components/common/modal/modal';

const LazyUserDraftsDialog = lazy(
  () => import(/* webpackChunkName: 'user-drafts-dialog' */ './UserDraftsDialog')
);

export const LIST_ROUTE = '/drafts';
export const SAVE_ROUTE = `${LIST_ROUTE}/save`;
export const SAVE_MEMENTO_ROUTE = `${SAVE_ROUTE}/memento`;

export const AsyncUserDraftsDialog = () => {
  const navigate = useNavigate();
  const isModalOpen = Boolean(useMatch({ path: LIST_ROUTE, end: false }));
  const isSaveView = Boolean(useMatch({ path: SAVE_ROUTE, end: false }));
  const activeUserDraft = useSelector(getActiveUserDraft);

  const title = t('draft.nav.view');

  // if the save view without an active user draft is visible we want to focus on the name input
  const preventModalFocus = isSaveView && !activeUserDraft;

  return (
    <Modal
      open={isModalOpen}
      title={title}
      type={ModalTypes.panel}
      onClose={() => navigate('/')}
      preventModalFocus={preventModalFocus}
    >
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <Suspense fallback={<LoadingOverlay />}>
          <LazyUserDraftsDialog />
        </Suspense>
      </ModalContent>
    </Modal>
  );
};
